import { useEffect } from "react";
import { useLocation } from "@tanstack/react-router";
import { consumeProviderRedirect } from "@/lib/checkout-return";
import { trackFunnel } from "@/lib/funnel";

/** Paths that mean the visitor came back having completed payment. */
const COMPLETION_PATHS = ["/checkout/complete", "/checkout/success", "/youre-in"];

/**
 * Mounted once in __root. When a visitor returns to the site after being
 * handed to Stripe or PayPal, records whether they came back through a
 * completion page (paid) or anywhere else (saw the payment screen and
 * stopped). This is the only reliable signal for a provider-side drop-off,
 * since the provider's own page cannot be instrumented by us.
 */
export function ProviderReturnTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    const pending = consumeProviderRedirect();
    if (!pending) return;

    const completed = COMPLETION_PATHS.some((p) => pathname.startsWith(p));
    const seconds = Math.round((Date.now() - pending.at) / 1000);
    const props = {
      provider: pending.provider,
      seconds_at_provider: seconds,
      returned_to: pathname,
    };

    trackFunnel(
      completed ? "provider_checkout_returned" : "provider_checkout_abandoned",
      { source: "provider_return", provider: pending.provider },
      props,
    );
  }, [pathname]);

  return null;
}
